export const generateFieldId = name => `FIELD:${name && name.trim()}`;



// WEBPACK FOOTER //
// ./src/util/ids.js